import dataPeriApi from "../../../../src/data/periprocedureel-beleid-apixaban.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriApi,
  BasicCollapse,
  React
};